import * as React from "react";
import * as _ from "lodash";

interface SwitchProps {
    value: any;
    children?: React.ReactChildren;
}

export class Switch extends React.Component<SwitchProps, {}> {

    getChildren() {
        return React.Children.map(this.props.children, (child: React.ReactElement<any>) => {
            var c = (child as any);
            if (c.props && c.props.value && c.type == Case) {
                if (_.isEqual(c.props.value, this.props.value)) {
                    return c;
                } else {
                    return null;
                }
            } else {
                console.warn("Only Case children allowed for Switch");
                return null;
            }
        });
    }

    render() {
        return <span>{this.getChildren()}</span>

    }
}

export class Case extends React.Component<{ value?: any, children?: React.ReactChildren; }, {}> {
    render() {
        return (
            <span>
                {this.props.children}
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/form/Switch.tsx